// extracted by mini-css-extract-plugin
module.exports = {"stats":"styles_stats__AEBFF","mobile":"styles_mobile__67x9w"};